import { render, staticRenderFns } from "./button-card.vue?vue&type=template&id=a6c5ad62&scoped=true"
import script from "./button-card.vue?vue&type=script&lang=js"
export * from "./button-card.vue?vue&type=script&lang=js"
import style0 from "./button-card.vue?vue&type=style&index=0&id=a6c5ad62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c5ad62",
  null
  
)

export default component.exports